import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSystemSettingReportsWritingDelayPenalty, TSystemSettingReportsWritingDelayPenaltyPayload, TSystemSettingReportsWritingDelayPenaltyResponse, adaptSystemSettingReportsWritingDelayPenaltyFromResponse } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS_WRITING_DELAY_PENALTY } from '../../backend-paths';


export const systemSettingReportsWritingDelayPenaltyUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS_WRITING_DELAY_PENALTY}`,
	(payload: TSystemSettingReportsWritingDelayPenaltyPayload, thunkApi) => {
		const path = BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS_WRITING_DELAY_PENALTY;

		return HttpService.put<TSystemSettingReportsWritingDelayPenaltyResponse>(path, payload).then(result => {
			return adaptSystemSettingReportsWritingDelayPenaltyFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TSystemSettingReportsWritingDelayPenalty> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const systemSettingReportsWritingDelayPenaltyUpdateSlice = createSlice({
	name: 'systemSettingReportsWritingDelayPenaltyUpdateSlice',
	initialState,
	reducers: {
		clearSystemSettingReportsWritingDelayPenaltyUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[systemSettingReportsWritingDelayPenaltyUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[systemSettingReportsWritingDelayPenaltyUpdateApi.fulfilled.type]: (state, action: PayloadAction<TSystemSettingReportsWritingDelayPenalty>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[systemSettingReportsWritingDelayPenaltyUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useSystemSettingReportsWritingDelayPenaltyUpdateSelector = () => useAppSelector(state => state[systemSettingReportsWritingDelayPenaltyUpdateSlice.name]);

export const { clearSystemSettingReportsWritingDelayPenaltyUpdate } = systemSettingReportsWritingDelayPenaltyUpdateSlice.actions;
